export const CONTADOR_PACK_SECTION_OPTIONS = [
  { id: 'ventas', label: 'Ventas (CSV)' },
  { id: 'egresos', label: 'Egresos (CSV)' },
  { id: 'impagas', label: 'Impagas (CSV)' },
  { id: 'pyl', label: 'Estado de resultados (CSV)' },
  { id: 'resumen', label: 'Resumen (PDF)' },
];

export const DEFAULT_CONTADOR_PACK_SECTIONS = Object.fromEntries(
  CONTADOR_PACK_SECTION_OPTIONS.map((s) => [s.id, true]),
);
